"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.RegisterContainer = exports.MIN_TX_HEIGHT = exports.EXPANSION_PANEL_HEIGHT = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const sharedStyles_1 = require("../sharedStyles");
const EXPANSION_PANEL_HEIGHT = ({ theme }) => theme.components.register.sectionHeaderHeight;
exports.EXPANSION_PANEL_HEIGHT = EXPANSION_PANEL_HEIGHT;
exports.MIN_TX_HEIGHT = {
    comfortable: 46,
    normal: 40,
    compact: 35,
};
exports.RegisterContainer = styled_components_1.default.div `
  margin-top: 0px;
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  &.tightmargins {
    margin: 5px 0px 0px 10px;
  }
`;
const styles = (theme) => (Object.assign(Object.assign({}, (0, sharedStyles_1.sharedStyles)(theme)), { txFooter: {
        height: 30,
    }, classNameProps: {
        height: 18,
        color: theme.palette.greyScaleDeprecated[0],
        marginLeft: 2,
    }, txSepSummary: {
        width: '100%',
        display: 'block',
        marginBottom: 0,
        background: theme.components.register.sectionHeaderColor,
        cursor: 'pointer',
        color: theme.palette.greyScaleDeprecated[0],
        borderBottom: `solid 1px ${theme.components.register.sectionHeaderBorder}`,
        borderRadius: '0px',
        marginTop: '-1px',
        minHeight: `${theme.components.register.sectionHeaderHeight}px`,
        lineHeight: `${theme.components.register.sectionHeaderHeight}px`,
        '& div': {
            marginTop: 0,
            marginBottom: 0,
        },
        '&.collapsed': {
            background: theme.components.register.sectionHeaderColor,
        },
        paddingLeft: 0,
    }, txSepIcon: {
        padding: 5,
    }, txSepHeading: {
        display: 'inline-block',
        marginTop: 0,
        marginBottom: 0,
        color: theme.palette.greyScaleDeprecated[0],
        padding: '0px 0px',
    }, clickable: {
        cursor: 'pointer',
    }, progressBar: {
        width: '50%',
        height: 13,
        marginLeft: 20,
        marginTop: 10,
    }, loadingStateContainer: {
        display: 'flex',
        width: '100vw',
        height: theme.defaults.content.height,
        justifyContent: 'center',
        alignItems: 'center',
    }, zeroStateContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 120,
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 18,
        color: theme.palette.greyScaleDeprecated[2],
        margin: 'auto',
    }, zeroStateTextHeadline: {
        marginBottom: 10,
        fontWeight: 50,
    }, zeroStateTextBody: {
        textAlign: 'center',
        maxWidth: '80%',
    }, VL: {
        background: theme.palette.greyScaleDeprecated[6],
        '& > div': {
            background: theme.palette.greyScaleDeprecated[7],
        },
        overflowX: 'hidden',
    }, txnListMenuItem: {
        padding: 0,
        height: 'auto',
        minHeight: 'auto',
    }, imgZeroState: {
        marginTop: 10,
        height: 64,
        width: 64,
    } }));
exports.styles = styles;
